import { observer as observerLite } from 'mobx-react-lite';
import * as React from 'react';
import { CommandBar, ICommandBarProps } from 'office-ui-fabric-react/lib/CommandBar';
import { CommandBarButton, IButtonProps, IButtonStyles } from 'office-ui-fabric-react/lib/Button';
import { computed } from 'mobx';
import { DisplayOption, FilterableCommandBarItem } from './FilterableMenuItem';
import { observer } from 'mobx-react';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getIsBitSet, ListViewBitFlagsMasks } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { getPalette } from 'owa-theme';

import * as styles from './FilterableCommandBar.scss';
const classNames = require('classnames/bind').bind(styles);
export interface FilterableCommandBarProps extends Partial<ICommandBarProps> {
    className?: string;
    elipisisAriaLabel?: string; // Users of FilterableCommandBar should expect an overflow ellipsis and should define a proper AriaLabel for it
    filterableItems: FilterableCommandBarItem[];
    style?: React.CSSProperties;
}

const FilterableCommandBarButton = observerLite((props: IButtonProps) => {
    const FilterableCommandBarButtonDefaultStyles: IButtonStyles = {
        root: classNames(
            isFeatureEnabled('fwk-fluentCommandBar') && styles.fluent,
            styles.commandBarButton
        ),
        rootDisabled: styles.disabled,
        rootExpanded: styles.expanded,
        icon: styles.icon,
        iconDisabled: styles.disabled,
        iconExpanded: styles.expanded,
        menuIcon: styles.menuIcon,
        menuIconDisabled: styles.disabled,
        menuIconExpanded: styles.expanded,
    };
    return (
        <CommandBarButton
            {...props}
            styles={{
                ...props.styles,
                ...FilterableCommandBarButtonDefaultStyles,
            }}
        />
    );
});

@observer
export default class FilterableCommandBar extends React.Component<FilterableCommandBarProps, {}> {
    @computed.struct
    private get validLeftItems(): FilterableCommandBarItem[] {
        return this.props.filterableItems
            ? this.props.filterableItems.filter(
                  item => !item.shouldShow || item.shouldShow(DisplayOption.Left)
              )
            : [];
    }

    @computed.struct
    private get validRightItems(): FilterableCommandBarItem[] {
        return this.props.filterableItems
            ? this.props.filterableItems.filter(
                  item => item.shouldShow && item.shouldShow(DisplayOption.Right)
              )
            : [];
    }

    @computed.struct
    private get validOverflowItems(): FilterableCommandBarItem[] {
        return this.props.filterableItems
            ? this.props.filterableItems.filter(
                  item => item.shouldShow && item.shouldShow(DisplayOption.Overflow)
              )
            : [];
    }

    render() {
        let { elipisisAriaLabel, styles } = this.props;

        const isSenderImageOff = getIsBitSet(ListViewBitFlagsMasks.HideSenderImage);

        let margins =
            isFeatureEnabled('tri-density-controls') && isSenderImageOff
                ? { margin: '0 4px' }
                : isFeatureEnabled('fwk-fluentCommandBar')
                ? { margin: '0', marginRight: '8px' }
                : { margin: '0 8px' };

        return (
            <CommandBar
                items={this.validLeftItems}
                farItems={this.validRightItems}
                overflowItems={this.validOverflowItems}
                overflowButtonProps={{ ariaLabel: elipisisAriaLabel }}
                buttonAs={FilterableCommandBarButton}
                overflowButtonAs={FilterableCommandBarButton}
                styles={{
                    primarySet: {
                        ...margins,
                    },
                    root: {
                        paddingLeft: '0',
                        background: getPalette().neutralLighter,
                    },
                    ...styles,
                }}
                {...this.props}
            />
        );
    }
}
